import script from "./FooterTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterTemplate.vue?vue&type=script&setup=true&lang=js"

import "./FooterTemplate.vue?vue&type=style&index=0&id=464e29a6&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-464e29a6"]])

export default __exports__